import React from "react";
import { useEffect, useState } from "react";

import { useFormik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";

// import Attachement from "./Attachement";

import * as yup from "yup";
import { notification } from "antd";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import Dashboard from "../../../../Components/Icons/Dasboard";
import { BackButton, CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import { NuDate, NuInput, NuInputText, NuLabel, NuSelect, NuTextArea } from "../../../../Components/Utils/Input";
import Attachements from "./Attachements";
import FormikSelectTwo, { FormikSelectWithAdd } from "../../../../Components/Utils/Select";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import DropDownAdd from "../../../../Components/Utils/selectAdd";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";

// import Attachement from "../Notes/Attachement";
const filetype = ["docx", "doc", "xlsx", "xls", "pdf", "txt", "pptx","mp4", "mov", "wmv", "avi", "flv", "mkv"];
// export const videotype = ["mp4", "mov", "wmv", "avi", "flv", "mkv"];

export default function CreateBids({ data }) {
  const {officeId} = useParams();
 const { value: biddingDivision } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "biddingDivision"
  );
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState([]);
  const [status, setStatus] = useState([]);
  const [createNew, setCreateNew] = useState({
    projectName:"",
    clientId:"",
    referenceNo:"",
    dueDate:null,
    submittedOn:"" ,
    submittedBy:null,
    submittedTo:null,
    comments:"",
    category:"",
    revision:"",
    bidValue:"",
    finalValue:"",
    biddingStatus:"",
    scopeOfWork:"",
    division:"",
    branchId:"",
  });


  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList,setFilePathList] =useState([])
  const [removefilePathList,setRemoveFilePathList] =useState([])
  const [proClient, setProClient] = useState([]);


  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = []
    files.map(item=>{
      if (item.size < maxFileSize ){
        fileArr.push(item)
      }else{
        api.warning({
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          placement: "bottomRight",
        });
      }
    })    
    let tempArr = []
    setSelectedFile(fileArr);
    files.map(item=>{
      if (item.size < maxFileSize ){
      let fileName = item?.name
      let fileExtention =  fileName.split(".").reverse()[0]
      if(filetype?.includes(fileExtention)){
        tempArr.push(fileName)
      }else{
        let x = URL.createObjectURL(item)
        tempArr.push(x)
      }
    }
    })
    setImage(tempArr)
  }

  // const getStatus = () => {
  //   axios
  //     .get(`/Metadata/noteStatus`)
  //     .then((res) => {
  //       let data = res.data?.data?.keyValues;
  //       let tempData = [];
  //       data.forEach((item) => {
  //         let tempObject = { value: item, label: item };
  //         tempData.push(tempObject);
  //       });
  //       res.data?.data?.keyValues && setStatus(tempData);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // const { data: PR } = UseDropDown(`/DropDown/${officeId}/client`);

  const getClients = async () => {
    await axiosInstance
      .get(`/DropDown/${officeId}/client`)
      .then((response) => {
        let FinalData = [];
        let status = response.data?.data;
        status.forEach((item) => {
          let tempObject = { value: item.clientId, label: item.companyName };
          FinalData.push(tempObject);
        });
        response.data?.data && setProClient(FinalData);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  // useEffect(() => {
  //   // getStatus();
  //   getClients()
  // }, []);



  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object({
        projectName: yup.string().required("Project Name is Required"),
        clientId: yup.string().required("Client is Required"),
    }),
    onSubmit: async (value) => {
      value.branchId = officeId
      setIsLoading(true);
      let formData = new FormData();
      formData.append("details", JSON.stringify(value));
      // formData.append("attachments", image.raw);
      if(selectedFile !== null){
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      }else{
        formData.append("attachments",[])
      } 

      data
        ? axiosInstance
            .put(`/bidding/update_bidding/${data?.biddingId}`, formData)
            .then((res) => {
              if (res.status == 201 || res.data.status == true) {
                setIsLoading(false);
                setImage({ preview: "", raw: "" });
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            })
        : axiosInstance
            .post("/bidding/create_bidding", formData)
            .then((res) => {
              if (res.status == 201 || res.data.status == true) {
                setIsLoading(false);
                setImage([]);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            });
    },
  });

  const { category: itemsCategory, subCategory: itemsSubCategory, getCategory, fetchSubCategory } = UseCatSubCatDropDown('/category/ItemCategory', "ItemCategory", formik?.values?.category);
   const [searchCustomer, setSearchCustomer] = useState("");
 
  const { data: customers, setDataCustomer } = UseCustomerDropDownNew(
    `/customers/drop-down/${officeId}/branch`,
    searchCustomer
  );
  return (
    <div className="w-full mx-auto py-2 px-4 ">
      {contextHolder}
      <div className="md:flex justify-end w-full">
      {/* <Breadcrumb
          items={[
           
            { name:"Bidding",
              link:`/main/${officeId}/bidding/bids`
             },
            { name:"Create" },
          ]}
        /> */}
       

        <div className=" flex gap-2 items-center ">
          <BackButton />
        </div>
      </div>
      <div>
      <div
          className=" w-full mx-auto h-[calc(100vh-145px)] rounded-md mt-2 overflow-y-scroll bg-white"
          // style={{ border: "1px solid #C5C5C5" }}
        >     <form onSubmit={formik.handleSubmit}>
          <div className=' w-full flex flex-wrap rounded-lg my-2'
          // style={{ border: "1px solid #ECEBF3" }}
          >
             <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Bidding :
                </p>
              </div>
           
             
                <NuInput
                 type="text"
                  label="Project Name"
                  isRequired={true}
                  placeholder="Project Name"
                  formik={formik}
                  name="projectName"
                  width="w-full md:w-1/2 lg:w-2/3"
                />

                {/* <NuInput
                 type="text"

                  label="Reference No"
                  isRequired={true}
                  placeholder="Reference No"
                  formik={formik}
                  name="referenceNo"
                  width="w-full md:w-1/2 lg:w-1/3"
                /> */}
 <FormikSelectTwo
                type="text"
                label="Client"
                placeholder="Client"
                Options={customers}
                formik={formik}
                name="clientId"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
                // px="0"
                // handleClick={togglePopup}
                setSearch={setSearchCustomer}
                FixPosition={true}
                PortalTarget={true}
              />
              <DropDownAdd
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={getCategory}
              categoryName={"ItemCategory"}
              displayProperty={"Add Category"}
              // isRequired={true}
            />

                {/* <FormikSelectTwo
                  label="Division"
                  Options={biddingDivision||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="division"
                  width="w-full md:w-1/2 lg:w-1/3"
                  // isRequired={true}
                /> */}
                 <NuDate
                  label="Bidding Due Date"
                  formik={formik}
                  name="dueDate"
                //   min={NuDate({
                //     value: Date.now(),
                //     format: "yyyy-MM-DD",
                //   })}
                  width=" w-full md:w-1/2 lg:w-1/3"
                />
                <NuInput
                 type="number"
                  label="Project Bid Value"
                  // isRequired={true}
                  placeholder="Project Bid Value"
                  formik={formik}
                  name="bidValue"
                  width="w-full md:w-1/2 lg:w-1/3"
                />


                <NuInput
                 type="number"
                  label="Final Bid Value"
                  // isRequired={true}
                  placeholder="Final Bid Value"
                  formik={formik}
                  name="finalValue"
                  width="w-full md:w-1/2 lg:w-1/3"
                />


                {/* <FormikSelectTwo
                  label="Client"
                  options={proClient}
                  formik={formik}
                  placeholder="Choose"
                  name="clientId"
                  width="w-full md:w-1/2 lg:w-1/3"
                  isRequired={true}
                /> */}



               

                <NuDate
                  label="Submitted On"
                  formik={formik}
                  name="submittedOn"
                //   min={NuDate({
                //     value: Date.now(),
                //     format: "yyyy-MM-DD",
                //   })}
                  width=" w-full md:w-1/2 lg:w-1/3"
                />

                {/* <NuInput
                 type="text"

                  label="Revision"
                  formik={formik}
                  placeholder="Revision"
                  name="revision"
                  width="w-full md:w-1/2 lg:w-1/3"
                  // isRequired={true}
                /> */}




                {/* <FormikSelectTwo
                  label="Status"
                  Options={biddingStatus||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="biddingStatus"
                  width="w-full md:w-1/2 lg:w-1/3"
                  // isRequired={true}
                /> */}

                <NuTextArea
                  label="Scope Of Work"
                  placeholder="Scope Of Work"
                  formik={formik}
                  name="scopeOfWork"
                  width="w-full md:w-1/2"
                  new_width='w-full md:w-2/3'
                />

                {/* <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                  width="w-full md:w-1/2"
                /> */}

<div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  Attachement :
                </p>
              </div>
                <Attachement
                  handleChange={handleImageChange}
                  preview={image || data?.imageUrl || ""}
                  width="w-full "
                  label="Attach"
                  multiple={true}

                />

            </div>
            <div className="flex justify-between items-center">
              <div className="w-1/2">

              </div>

              <div
                className=" mr-2 rounded-md"
                style={{ border: "1px solid #C5C5C5" }}
              >

              </div>
            </div>

            <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
              <CancelButton handleClick={() => navigate(-1)} />
              <SubmitButton isLoading={isLoading} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
